import { VEHICLE_TYPE_SUPER_DUTY_NAMES } from '../../../hooks/dyf/use-dyf-eligible-model/use-dyf-eligible-model';
import { getAemVehicleModelData } from '../../../hooks/use-aem-vehicle-model-data';
import { VehicleYmm } from '../../../models/vehicle-ymm';
import VehicleTypeService from '../../../services/vehicle-type-service/vehicle-type-service';

interface YmmParams {
    flow: 'vin' | 'ymm';
    queryVin: string;
    queryModel: string;
    queryYear: string;
    currentLanguageRegionCode: string;
    current3LetterCountryCode: string;
    currentRegionCode: string;
    brand: string;
}
export async function getYmmDetails(
    params: YmmParams
): Promise<VehicleYmm | undefined> {
    const {
        flow,
        queryVin,
        queryModel,
        queryYear,
        currentLanguageRegionCode,
        current3LetterCountryCode,
        currentRegionCode,
        brand,
    } = params;

    if (flow == 'vin' && queryVin !== '') {
        return await new VehicleTypeService()
            .vehicleType(
                queryVin,
                currentLanguageRegionCode,
                current3LetterCountryCode?.toUpperCase()
            )
            .then(vehicleData => {
                let vehicleName = vehicleData.vehicleData?.model;
                if (
                    vehicleName &&
                    VEHICLE_TYPE_SUPER_DUTY_NAMES.includes(
                        vehicleName.toLowerCase()
                    ) &&
                    parseInt(vehicleData.vehicleData?.year || '') > 2021
                ) {
                    // to get super-duty seokey, otherwise will fail
                    vehicleName = 'F-250';
                }
                return getAemVehicleModelData(
                    brand,
                    currentRegionCode,
                    currentLanguageRegionCode,
                    vehicleData.vehicleData?.year || '',
                    vehicleName ?? '',
                    'PTS_MARKET_NAME'
                ).then(res => res);
            });
    } else {
        return await getAemVehicleModelData(
            brand,
            currentRegionCode,
            currentLanguageRegionCode,
            queryYear,
            queryModel,
            'SEO_KEY'
        );
    }
}
